import Routines from "./routines";

export default [
  // Each object is a day
  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week10day1,
    title: "Advanced Core Strength II-A",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week10day2,
    title: "Advanced Core Strength II-B",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week10day1,
    title: "Advanced Core Strength II-A",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week10day2,
    title: "Advanced Core Strength II-B",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week10day1,
    title: "Advanced Core Strength II-A",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week10day2,
    title: "Advanced Core Strength II-B",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week10day1,
    title: "Advanced Core Strength II-A",
  },
];
